export default __webpack_public_path__ + "static/media/rounded-bag-2x.0979e8dc.webp";